'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const CustomerServiceIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M6 15.25V8.75C6 5.44 8.69 2.75 12 2.75C15.31 2.75 18 5.44 18 8.75V15.25C18 18.56 15.31 21.25 12 21.25M9 15C10.66 16.66 13.34 16.66 15 15M6 11H4.75C4.2 11 3.75 11.45 3.75 12V14.31C3.75 14.86 4.2 15.31 4.75 15.31H6V11ZM20.25 14.31V12C20.25 11.45 19.8 11 19.25 11H18V15.31H19.25C19.8 15.31 20.25 14.86 20.25 14.31Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpCustomerServiceIcon = forwardRef(CustomerServiceIcon);

export { VpCustomerServiceIcon as default };
